import { render, staticRenderFns } from "./RoleTable.vue?vue&type=template&id=2b4b2988&scoped=true&"
import script from "./RoleTable.vue?vue&type=script&lang=js&"
export * from "./RoleTable.vue?vue&type=script&lang=js&"
import style0 from "./RoleTable.vue?vue&type=style&index=0&id=2b4b2988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b2988",
  null
  
)

export default component.exports